import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=70347c0a"
import script from "./ResourceModal.vue?vue&type=script&lang=js"
export * from "./ResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports